var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14286 6.90176H14.7812M4.48512 1.4375V3.07698M15.3125 1.4375V3.07678M18.5 6.07678L18.5 17.5625C18.5 19.2194 17.1569 20.5625 15.5 20.5625H4.5C2.84315 20.5625 1.5 19.2194 1.5 17.5625V6.07678C1.5 4.41992 2.84315 3.07678 4.5 3.07678H15.5C17.1569 3.07678 18.5 4.41992 18.5 6.07678Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/Calender.fb86e6768a33e5eb964aee35b9a59b5c.svg";
export { ForwardRef as ReactComponent };